import customEventsNames from './../customEventsNames';

export function languageSwitchTrigger() {
    const trigger = document.getElementById('languageSwitchTrigger');
    const modal = document.getElementById('languageSwitchModal');
    const dismissLink = document.getElementById('dismissSwitchLink');
    if (!trigger || !modal) return;

    const openModal = () => {
        modal.dispatchEvent(
            new CustomEvent(customEventsNames.openModal, {
                bubbles: true,
                detail: { modalId: '#languageSwitchModal' }
            })
        );
    };

    trigger.addEventListener('click', openModal);

    if (dismissLink) {
        dismissLink.addEventListener('click', e => {
            e.preventDefault();
            modal.querySelector('.modal-close').click();
        });
    }

    openModal();
}